import React from 'react';
import {
  XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, CartesianGrid,
  BarChart, Bar, LabelList
} from "recharts";
import CountUp from 'react-countup';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useEffect } from 'react';
export default function TrainingDashboard() {
 useEffect(() => {
    window.scrollTo(0, 0); 
  }, []);

  const data = {
    title: "Job Fair Event Dashboard",
    stats: {
      NationalCareerExpo: 5,
      RegionalJobFair: 17,
     jobfair:18247,
      Companies: 500,
      candidate: 50590,
      Workshop: 15,
      campaign:66,
      Careerclub:17
      
    },
    expoRounds: [
      { round: '2020', companies: 100, candidates: 4313 },
      { round: '2021', companies: 90, candidates: 2777 },
      { round: '2022', companies: 56, candidates: 10343 },
      { round: '2023', companies: 176, candidates: 11556},
      { round: '2024', companies: 250, candidates: 15676 },
      { round: '2025', companies: 0, candidates: 0 },
    ],
    
  };

  const COLORS = {
    primary: '#FE5D26',
    secondary: '#FF9B45',
    accent: '#E52020',
    light: '#FFC107',
    dark: '#333333',
    info: '#4A90E2',
    success: '#8BC34A'
  };

  // Animation styles
  const cardHoverStyle = {
    transform: 'translateY(-5px)',
    boxShadow: '0 10px 20px rgba(0,0,0,0.1)'
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f8fafc',
      padding: '2rem',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
    }}>
      {/* Header */}
      <div style={{
        textAlign: 'center',
        marginBottom: '3rem'
      }}>
        <h1 style={{
          fontSize: '2.5rem',
          fontWeight: '700',
          marginBottom: '0.5rem',
          background: 'linear-gradient(45deg, #FE5D26 30%, #FF9B45 90%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          display: 'inline-block'
        }}>
          {data.title}
        </h1>
        <p style={{
          color: '#64748b',
          fontSize: '1.1rem'
        }}>
          Comprehensive overview of job fair events and participation
        </p>
      </div>

      {/* Stats Cards */}
      <div  style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '1.5rem',
        marginBottom: '3rem'
      }}>
        {/* National Career Expo */}
        <div className="relative group inline-block" style={{
          backgroundColor: 'white',
          padding: '1.5rem',
          borderRadius: '0.75rem',
          boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
          transition: 'all 0.3s ease',
          borderLeft: `4px solid ${COLORS.primary}`,
          ':hover': cardHoverStyle
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <div>
              <p style={{
                fontSize: '0.875rem',
                fontWeight: '500',
                color: '#64748b',
                marginBottom: '0.25rem'
              }}>
                National Career Expo
              </p>
              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: '700',
                color: '#1e293b'
              }}>
                <CountUp end={data.stats.NationalCareerExpo} duration={2} />
              </h3>
              <p className="text-[13px] font-semibold text-orange-600 mt-2">52322+ Candidates</p>
            </div>
             <div className='flex flex-col items-center'>
            <div style={{
              backgroundColor: 'rgba(254, 93, 38, 0.1)',
              padding: '0.75rem',
              borderRadius: '50%',
              display: 'inline-flex'
            }}>
              <svg width="24" height="24" fill="none" stroke={COLORS.primary} viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>  
            </div>
            <p className="text-[13px] font-semibold text-orange-600 mt-2">646+ companies</p>
          </div>
 <div className="absolute left-0 bottom-full mb-2 hidden w-64 p-2 text-xs text-white bg-orange-400 rounded shadow-md group-hover:block transition-opacity duration-300">
    <strong>National Career Expo:</strong> A nationa career expo event bringing companies and fresh graduates from across Ethiopia.<br />
  </div>
        </div>
        
</div>
        {/* Regional Job Fair */}
        <div className="relative group inline-block" style={{
          backgroundColor: 'white',
          padding: '1.5rem',
          borderRadius: '0.75rem',
          boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
          transition: 'all 0.3s ease',
          borderLeft: `4px solid ${COLORS.secondary}`,
          ':hover': cardHoverStyle
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <div>
              <p style={{
                fontSize: '0.875rem',
                fontWeight: '500',
                color: '#64748b',
                marginBottom: '0.25rem'
              }}>
                Regional Job Fair
              </p>
              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: '700',
                color: '#1e293b'
              }}>
                <CountUp end={data.stats.RegionalJobFair} duration={2} />
              </h3>
               <p className="text-[12px] font-semibold text-orange-600 mt-2">7 Partner universities </p>
            </div>
            <div style={{
              backgroundColor: 'rgba(255, 155, 69, 0.1)',
              padding: '0.75rem',
              borderRadius: '50%',
              display: 'inline-flex'
            }}>
              <svg width="24" height="24" fill="none" stroke={COLORS.secondary} viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
              </svg>
            </div>
          </div>
           <div className="absolute left-0 bottom-full mb-2 hidden w-64 p-2 text-xs text-white bg-orange-400 rounded shadow-md group-hover:block transition-opacity duration-300">
    <strong>Regional Career Expo:</strong> A career expo organized in various regional universities to engage candidates with companies in their home town.
  </div>
        </div>
 <div style={{
          backgroundColor: 'white',
          padding: '1.5rem',
          borderRadius: '0.75rem',
          boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
          transition: 'all 0.3s ease',
          borderLeft: `4px solid ${COLORS.accent}`,
          ':hover': cardHoverStyle
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <div>
              <p style={{
                fontSize: '0.875rem',
                fontWeight: '500',
                color: '#64748b',
                marginBottom: '0.25rem'
              }}>
                Candidates
              </p>
              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: '700',
                color: '#1e293b'
              }}>
                <CountUp end={data.stats.candidate} duration={2} />+
              </h3>
               <p className="text-[13px] font-semibold text-orange-600 mt-2">1% PWD</p>
            </div>
            <div className='flex flex-col items-center'>
            <div style={{
              backgroundColor: 'rgba(229, 32, 32, 0.1)',
              padding: '0.75rem',
              borderRadius: '50%',
              display: 'inline-flex'
            }}>
              <svg className="w-6 h-6 text-[#E52020]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
             <p className="text-[13px] font-semibold text-orange-600 mt-2">33% Female</p>
            </div>
          </div>
        </div>
        {/* Companies */}
        <div style={{
          backgroundColor: 'white',
          padding: '1.5rem',
          borderRadius: '0.75rem',
          boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
          transition: 'all 0.3s ease',
          borderLeft: `4px solid ${COLORS.accent}`,
          ':hover': cardHoverStyle
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <div>
              <p style={{
                fontSize: '0.875rem',
                fontWeight: '500',
                color: '#64748b',
                marginBottom: '0.25rem'
              }}>
                Companies Involved
              </p>
              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: '700',
                color: '#1e293b'
              }}>
                <CountUp end={data.stats.Companies} duration={2} />+
              </h3>
              <p className="text-[13px] font-semibold text-orange-600 mt-2">30,000+ Job opportunities</p>
            </div>
          
            <div style={{
              backgroundColor: 'rgba(229, 32, 32, 0.1)',
              padding: '0.75rem',
              borderRadius: '50%',
              display: 'inline-flex'
            }}>
              <svg width="24" height="24" fill="none" stroke={COLORS.accent} viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
              </div>
          </div>
        </div>

      <div className="relative group inline-block" style={{
          backgroundColor: 'white',
          padding: '1.5rem',
          borderRadius: '0.75rem',
          boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
          transition: 'all 0.3s ease',
          borderLeft: `4px solid ${COLORS.accent}`,
          ':hover': cardHoverStyle
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <div>
              <p style={{
                fontSize: '0.875rem',
                fontWeight: '500',
                color: '#64748b',
                marginBottom: '0.25rem'
              }}>
              Career Club
              </p>
              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: '700',
                color: '#1e293b'
              }}>
                <CountUp end={data.stats.Careerclub} duration={2} />+
              </h3>
               <p className="text-[13px] font-semibold text-orange-600 mt-2">Partner Universities</p>
            </div>
            <div className='flex flex-col items-center'>
            <div style={{
              backgroundColor: 'rgba(229, 32, 32, 0.1)',
              padding: '0.75rem',
              borderRadius: '50%',
              display: 'inline-flex'
            }}>
              <svg width="24" height="24" fill="none" stroke={COLORS.accent} viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg> 
            </div>
             <p className="text-[13px] font-semibold text-orange-600 mt-2">7,864+ members</p>
            </div>
             <div className="absolute left-0 bottom-full mb-2 hidden w-64 p-2 text-xs text-white bg-orange-400 rounded shadow-md group-hover:block transition-opacity duration-300">
    A student-led platform that empowers university students with career readiness skills, mentorship, and employer connections  helping them confidently transition from campus to the workforce.
  </div>
          </div>
        </div>
        
        
        
<div className="group relative inline-block rounded-xl bg-white p-6 shadow transition-all hover:shadow-lg">
        <div className="flex justify-between items-center">
           
        <div>
          <p className="text-sm font-medium text-slate-500 mb-1">Workshop</p>
          <h3 className="text-2xl font-bold text-slate-800">
            <CountUp end={data.stats.Workshop} duration={2} />
          </h3>
             <p className="text-[13px] font-semibold text-orange-600 mt-2">10+ Breakfast Forum</p>
        </div>
        <div className="flex flex-col items-center">
        <div className="inline-flex p-3 rounded-full bg-orange-100/40">
        <svg
         width="24" height="24" fill="none" stroke={COLORS.light} viewBox="0 0 24 24"
         strokeWidth="2"
         strokeLinecap="round"
         strokeLinejoin="round"
        >
  <path d="M3 11V7a1 1 0 011-1h3l4-4v20l-4-4H4a1 1 0 01-1-1v-4" />
  <path d="M15 9h5l3 3-3 3h-5" />
</svg>

          </div>
          <p className="text-[13px] font-semibold text-orange-600 mt-2">
         
          </p>
        </div>
      </div>


<div className="absolute left-0 bottom-full mb-2 hidden w-64 p-2 text-xs text-white bg-orange-400 rounded shadow-md group-hover:block transition-opacity duration-300">
     The annual workshops and Breakfast Forum bring together universities, government, employers, and stakeholders to strengthen partnerships, align on labor market needs, and collaboratively plan for the job fair through discussions on industry trends and expectations.
  </div>
     
    </div>

      <div className="group relative rounded-xl bg-white p-6 shadow transition-all hover:shadow-lg">
      
      <div className="flex justify-between items-center">
        <div>
          <p className="text-sm font-medium text-slate-500 mb-1">Campaign</p>
          <h3 className="text-2xl font-bold text-slate-800">
            <CountUp end={data.stats.campaign} duration={2} />+
          </h3>
        </div>

        <div className="flex flex-col items-center">
        <div className="inline-flex p-3 rounded-full bg-orange-100/40">
        <svg
         width="24" height="24" fill="none" stroke={COLORS.light} viewBox="0 0 24 24"
         strokeWidth="2"
         strokeLinecap="round"
         strokeLinejoin="round"
        >
  <path d="M3 11V7a1 1 0 011-1h3l4-4v20l-4-4H4a1 1 0 01-1-1v-4" />
  <path d="M15 9h5l3 3-3 3h-5" />
</svg>

          </div>
          <p className="text-[13px] font-semibold text-orange-600 mt-2">
            34462+ Participants
          </p>
        </div>
      </div>

      <div className="absolute left-0 bottom-full mb-2 hidden w-64 p-2 text-xs text-white bg-orange-400 rounded shadow-md group-hover:block transition-opacity duration-300">
    A coordinated initiative carried out over a specific timeframe to attract candidates by organizing focused events across 51 universities
  </div>
      
    </div>
 <div style={{
          backgroundColor: 'white',
          padding: '1.5rem',
          borderRadius: '0.75rem',
          boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
          transition: 'all 0.3s ease',
          borderLeft: `4px solid ${COLORS.accent}`,
          ':hover': cardHoverStyle
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <div>
              <p style={{
                fontSize: '0.875rem',
                fontWeight: '500',
                color: '#64748b',
                marginBottom: '0.25rem'
              }}>
                Job_Fair Placed
              </p>
              <h3 style={{
                fontSize: '1.5rem',
                fontWeight: '700',
                color: '#1e293b'
              }}>
                <CountUp end={data.stats.jobfair} duration={2} />+
              </h3>
              <p className="text-[13px] font-semibold text-orange-600 mt-2">38% Female</p>
            </div>
          
            <div style={{
              backgroundColor: 'rgba(229, 32, 32, 0.1)',
              padding: '0.75rem',
              borderRadius: '50%',
              display: 'inline-flex'
            }}>
              <svg className="w-6 h-6 text-[#E52020]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
              </div>
          </div>
        </div>
      </div>

   
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(500px, 1fr))',
        gap: '2rem',
        marginBottom: '3rem'
      }}>
        {/* National Career Expo Rounds */}
        <div style={{
          backgroundColor: 'white',
          padding: '1.5rem',
          borderRadius: '0.75rem',
          boxShadow: '0 4px 6px rgba(0,0,0,0.05)'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alsignItems: 'center',
            marginBottom: '1.5rem'
          }}>
            <h2 style={{
              fontSize: '1.25rem',
              fontWeight: '700',
              color: '#1e293b'
            }}>
              National Career Expo - Participation by year
            </h2>
            <span style={{
              backgroundColor: COLORS.primary,
              color: 'white',
              padding: '0.25rem 0.75rem',
              borderRadius: '9999px',
              fontSize: '0.75rem',
              fontWeight: '700'
            }}>
               Data
            </span>
          </div>
          <div style={{ height: '400px' }}>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                data={data.expoRounds}
                margin={{ top: 20, right: 30, left: 20, bottom: 60 }}
              >
                <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                <XAxis 
                  dataKey="round" 
                  angle={-45} 
                  textAnchor="end" 
                  height={70}
                  tick={{ fill: '#334155' }}
                />
                <YAxis 
                  yAxisId="left" 
                  orientation="left" 
                  stroke={COLORS.primary}
                  tickFormatter={(value) => `${value}`}
                />
                <YAxis 
                  yAxisId="right" 
                  orientation="right" 
                  stroke={COLORS.secondary}
                  tickFormatter={(value) => `${(value / 1000).toFixed(0)}k`}
                />
              <Tooltip 
  formatter={(value, name) => {
    let formattedValue = value;
    let displayName = name;

    if (name === 'companies') {
      formattedValue = value;
      displayName = 'Companies';
    } else if (name === 'candidates') {
      formattedValue = `${(value / 1000).toFixed(1)}k`;
      displayName = 'Candidates';
    }

    return [formattedValue, displayName];
  }}
  contentStyle={{
    backgroundColor: 'white',
    borderRadius: '0.5rem',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
    border: 'none',
    padding: '0.75rem'
  }}
/>

 <Legend />
                <Bar 
                  yAxisId="left"
                  dataKey="companies" 
                  name="Companies" 
                  fill={COLORS.primary} 
                  radius={[4, 4, 0, 0]}
                >
                  <LabelList 
                    dataKey="companies" 
                    position="top" 
                    formatter={(value) => value}
                    fill="#334155"
                  />
                </Bar>
                <Bar 
                  yAxisId="right"
                  dataKey="candidates" 
                  name="Candidates" 
                  fill={COLORS.secondary} 
                  radius={[4, 4, 0, 0]}
                >
                  <LabelList 
                    dataKey="candidates" 
                    position="top" 
                    formatter={(value) => `${(value / 1000).toFixed(1)}k`}
                    fill="#334155"
                  />
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        
<div className="bg-white p-6 rounded-xl shadow-lg max-w-5xl mx-auto font-sans text-sm">
  <h2 className="text-lg font-bold text-slate-800 mb-4 text-center border-b pb-2">
    🧭 Regional Jobfair Summary
  </h2>

  <div className="overflow-x-auto rounded-lg">
    <table className="min-w-full table-auto border-collapse">
      <thead className="bg-slate-100 text-slate-600 uppercase text-xs tracking-wider">
        <tr>
          <th className="text-left py-2 px-3 border-b">University</th>
          <th className="text-left py-2 px-3 border-b">Candidates</th>
          <th className="text-left py-2 px-3 border-b">Companies</th>
          <th className="text-left py-2 px-3 border-b">Event Year</th>
        </tr>
      </thead>
      <tbody>
        {[
          ["Jimma University", 1341, 54, "2022, 2024"],
          ["Hawassa University", 3112, 81, "2021, 2022, 2024"],
          ["BahirDar University",2328,59,"2023,2024"],
          ["Addis Ababa University", 950, 56, "2022"],
          ["Adama Science And Technology University", 178, 23, "2023"],
          ["Wollo University (Main Campus)", 2571, 84, "2023, 2024"],
          ["Haramaya University", 2328, 59, "2021, 2022, 2024"]
        ].map(([university, candidates, companies, year], idx) => (
          <tr key={idx} className={idx % 2 === 0 ? "bg-white" : "bg-slate-50"}>
            <td className="py-2 px-3 border-b text-slate-700">{university}</td>
            <td className="py-2 px-3 border-b text-slate-700">{candidates.toLocaleString()}</td>
            <td className="py-2 px-3 border-b text-slate-700">{companies}</td>
            <td className="py-2 px-3 border-b text-slate-700">{year}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
</div>

        
      </div>
 <div className="mt-6">
  <h4 className="text-md font-semibold text-gray-700 mb-2">Highlights from the Program</h4>
  <Slider
    dots={false}
    infinite={true}
    speed={500}
    slidesToShow={3}
    slidesToScroll={1}
    autoplay={true}
    autoplaySpeed={3000}
    arrows={false}
    className="mx-4"
  >
    {[
      "/assets/img3.jpg",
      "/assets/g2.jpg",
      "/assets/g4.jpg",
      "/assets/g5.jpg",
    ].map((src, index) => (
      <div key={index} className="px-2">
        <img
          src={src}
          alt={`Slide ${index + 1}`}
          className="rounded-lg shadow-md h-40 w-full object-cover"
        />
      </div>
    ))}
  </Slider>
</div>
      
    </div>
  );
}